module.exports = __webpack_public_path__ + "static/img/kf-ewm.dda892b5.png";